import React, { useState, useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import Chart from "react-apexcharts";
import axios from "axios";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";

import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import {
  getTradesData,
  getTradesFromDatabase,
  setReportsLoading,
  setReportsLoadingFinished,
  setTradesLoading,
  setTradesLoadingFinished,
} from "../../actions/tradesActions";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Fade from "@mui/material/Fade";

import Spinner from "../common/Spinner";
import { faIR } from "@mui/x-data-grid";
import { type } from "@testing-library/user-event/dist/type";
import { LineWeight } from "@mui/icons-material";
import { GET_TRADES } from "../../actions/types";
import PopupPortal from "./PopupPortal";
import { abrirPopup } from "./popupController";
import ApexCharts from "apexcharts";
import { useUI } from "../context/UIContext";

const formato = (v) =>
  v ? `COP ${Number(v).toLocaleString('es-CO')}` : 'COP 0';

function buildDetalleHTML({ w, series, dataPointIndex, detalleGastos }) {
  let html = `<div class="tooltip-gastos" style="padding:10px 12px; min-width:280px">`;

  const mes = w.globals.labels?.[dataPointIndex] ?? `Mes ${dataPointIndex + 1}`;
  //html += `<div style="font-weight:600; margin-bottom:8px">${mes}</div>`;

  const detalleMes = detalleGastos?.[dataPointIndex] || {};

  const detallesHTML = Object.entries(detalleMes)
    .filter(([k, v]) => Number(v) > 0)
    .map(([key, value]) => `
      <div style="display:flex; justify-content:space-between; gap:12px">
        <span>${key.replaceAll('_', ' ')}</span>
        <b>${formato(value)}</b>
      </div>
    `)
    .join('');

  html += detallesHTML || `<i style="opacity:.7"></i>`;
  html += `</div>`;

  return html;
}

function renderMiniChart(series, dataPointIndex, detalle) {
  const el = document.querySelector("#miniChart");
  if (!el) return;

  const detalleMes = detalle?.[dataPointIndex] || {};

  // 👇 AQUÍ va tu bloque (Top 8 subcuentas)
  const entries = Object.entries(detalleMes)
    .map(([k, v]) => [k, Number(v) || 0])
    .filter(([, v]) => v > 0)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10);   // ⬅️ top 8

  const categorias = entries.map(([k]) => k.replaceAll('_', ' '));
  const data = entries.map(([, v]) => v);

  const options = {
  chart: {
    type: "bar",
    height: 360,
    toolbar: { show: false }
  },
  plotOptions: {
    bar: {
      horizontal: true,
      barHeight: "60%",
      borderRadius: 6
    }
  },
  series: [{ name: "Gastos", data }],
  xaxis: {
    labels: {
      show: false   // ⬅️ ocultamos labels del eje para que no se monten
    }
  },
  yaxis: {
    labels: {
      show: false   // ⬅️ ocultamos categorías en el eje
    }
  },
  tooltip: {
    fixed: {
    enabled: true,
    position: "center",   // 👈 centro del chart
    offsetX: 0,
    offsetY: 0
  },
    shared: false,
    intersect: true,
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      const categoria = categorias[dataPointIndex]; // nombre de subcuenta
      const valor = series[seriesIndex][dataPointIndex];
      return `
        <div style="padding:8px 10px; min-width:200px">
          <div style="font-weight:600; margin-bottom:4px">${categoria}</div>
          <div>Valor: <b>COP ${Number(valor).toLocaleString('es-CO')}</b></div>
        </div>
      `;
    }
  }
};



  new ApexCharts(el, options).render();
}




function arrayFilter(array, max) {
  let newArray = [];
  for (let i = 0; i < array.length - 2; i += array.length / max) {
    newArray.push(array[parseInt(i)]);
  }
  newArray.push(array[array.length - 1]);
  return newArray;
}

export default function ReportsOverview({ selected, filters }) {
  const expired = useSelector((store) => store.auth.user.expired);
  const userId = useSelector((store) => store.auth.user.public_id);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const loading_reports = useSelector((store) => store.trades.loading_reports);
 

  useEffect(() => {
    if (expired) {
      navigate("/profile/account_plan");
      enqueueSnackbar("Your Account is Expired", {
        variant: "error",
      });
    }
  }, [expired, navigate, enqueueSnackbar]);

  const [EstadoData, setEstadoData] = useState(true);
  const [EstadoAnual, setEstadoAnual] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [totalVentas, setTotalVentas] = useState();
  const [totalCostos, setTotalCostos] = useState();
  const [totalGastos, setTotalGastos] = useState();
  const [totalEbitda, setTotalEbitda] = useState();
  const [textoAño, setTextoAño] = useState('');
  const [ventasArea, setventasArea] = useState();
  const [costosArea, setcostosArea] = useState();
  const [gastosArea, setgastosArea] = useState();
  const [ChartDataRegiones,setChartDataRegiones]= useState();
  const [ChartDataAsesores,setChartDataAsesores]= useState();
  const [RegionVentas,setRegionVentas]= useState({});
  const [cobrosArea, setcobrosArea] = useState();
  const [pagosArea, setpagosArea] = useState();
  const [inventarioArea, setinventarioArea] = useState();
  const [liquidezArea, setliquidezArea] = useState();
  const [pruebaacida, setpruebaacidaArea] = useState();
  const [capitaltrabajo, setcapitaltrabajoArea] = useState();
  const [endeudamientoArea, setendeudamientoArea] = useState();
  const [apalancamientoArea, setapalancamientoArea] = useState();
  const [totalUtilidadNeta, settotalUtilidadNeta] = useState();

  const location = useLocation();

  const { tabValue } = useUI();

  const trades = useSelector((store) => store.trades);

  const toMoney = value => {
    const money = Number(value);
    if (isNaN(money)) {
      return value;
    }

    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0  }).format(Math.floor(money))
  }

 

 
  const [optionColumnChart, setOptionColumnChart] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "80%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });

  const [ejemploTortaChart1, setEjemploTortaChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  })

  
  
  const [ejemploChart1, setejemploChart] = useState({
    name: "",
    color: "#00E396",
    data: [],
  })
  
  const [ejemploOptionChart1, setEjemploOptionColumnChart] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "30%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });


 


  const [ejemploChart2, setejemploChart2] = useState({
    name: "",
    color: "#00E396",
    data: [],
  
  })
  
  const [ejemploOptionChart2, setEjemploOptionColumnChart2] = useState({
  series:[],
  options:{
    chart: {
      type: "bar",
      height: 500,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "30%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: { categories: ['enero-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']},
  }
  });



  const [ejemploOptionChart4, setEjemploOptionColumnChart4] = useState({
    series:[],
    options:{
      chart: {
        type: "bar",
        stacked: true,
        height: 350,
      },
      plotOptions: {
        bar: {
          colors: {
            ranges: [
              {
                from: -100,
                to: -46,
                color: "#F15B46",
              },
              {
                from: -45,
                to: 0,
                color: "#FEB019",
              },
            ],
          },       
          horizontal: false,
          borderRadius: 0,
          borderRadiusApplication: 'around',
          borderRadiusWhenStacked: 'last',
          columnWidth: '70%',
          barHeight: '200%',
          distributed: false,
          rangeBarOverlap: true,
          rangeBarGroupRows: false,
          hideZeroBarsWhenGrouped: false,
          isDumbbell: false,
          dumbbellColors: undefined,
          isFunnel: false,
          isFunnel3d: true
        },
      },
      dataLabels: {
        enabled: false,
                formatter: function (val) {
                  return val + "%";
                },
                offsetY: -50,
                style: {
                  fontSize: '12px',
                  colors: ["#304758"]
                }
      },
      yaxis: {
        labels: {
          formatter: function (y) {
            return y.toFixed(2);
          },
        },
      },
      xaxis: { categories: ['eseero-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']},
    }
    });



    const [ejemplolinea, setejemplolinea] = useState({
      
       options : {
        series: [
      ],
        chart: {
        height: 350,
        stacked: true,
        type: 'line',
        toolbar: {
          show: false,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
      },
    },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: [1, 1, 4]
      },
      grid: {
        show:false,
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        },
      },
      markers: {
        size: 1
      },
      title: {
        text: 'Evolución ingresos vs costos',
        //offsetX: 110
      },
      xaxis: {
        categories: [2021, 2022, 2023, 2024],
      },
      yaxis: [
        {
          min: 0,
          max: 800000000,
          seriesName: 'Income',
          title: {
            text: '',
          },
        },
        {
          min: 0,
          max: 800000000,
          seriesName: 'Cashflow',
          labels: {
            show: false,
          },
          opposite: true,
          axisTicks: {
            show: false,
          },
        },
        {
          min: 0,
          max: 50,
          seriesName: 'Revenue',
          labels: {
            show: true,
          },
          opposite: true,
          title: {
            text: '',
          },
        },
       
      ],
      tooltip: {
        fixed: {
          enabled: true,
          position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
          offsetY: 30,
          offsetX: 60
        },
        y: [{
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(0) + "$";
            }
            return y;
            
          }
        }, {
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(2) + "$";
            }
            return y;
            
          }},
          {
            formatter: function (y) {
              if(typeof y !== "undefined") {
                return  y.toFixed(4) + "%";
              }
              return y;
              
            }
        }]
      },
      legend: {
        horizontalAlign: 'left',
        offsetX: 40
      }
      }

     
    
    
      });




      const [ejemplolinea2, setejemplolinea2] = useState({
      
        options : {
         series: [
       ],
         chart: {
         height: 350,
         stacked: true,
         type: 'line',
         toolbar: {
          show: false,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
       },
      },
       dataLabels: {
         enabled: false
       },
       stroke: {
         curve: 'smooth',
         width: [1, 1, 1,4]
       },
       plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            total: {
              enabled: false,
              offsetX: 0,
              style: {
                fontSize: '13px',
                fontWeight: 900
              }
            }
          }
        },
      },
       grid: {
         show:false,
         borderColor: '#e7e7e7',
         row: {
           colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
           opacity: 0.5
         },
       },
       markers: {
        size: 1
      },
       title: {
         text: 'Gastos admon y ventas',
         //offsetX: 110
       },
       xaxis: {
         categories: [2021, 2022, 2023, 2024],
       },
       yaxis: [
         {
          min: 0,
          max: 800000000,
           seriesName: 'ventas',
           title: {
             text: '',
           },
         },
         {
          min: 0,
          max: 800000000,
           seriesName: 'Gastos administracion',
           labels: {
             show: false,
           },
           opposite: false,
           axisTicks: {
             show: false,
           },
         },

         {
          min: 0,
          max: 800000000,
          seriesName: 'Gastos ventas',
          labels: {
            show: false,
          },
          opposite: true,
          axisTicks: {
            show: false,
          },
        },
        {
          min: 0,
          max: 50,
          seriesName: 'Revenue',
          labels: {
            show: true,
          },
          opposite: true,
          title: {
            text: '',
          },
        },
      
        
       ],
       tooltip: {
         fixed: {
           enabled: true,
           position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
           offsetY: 30,
           offsetX: 60
         },
         y: [{
           formatter: function (y) {
             if(typeof y !== "undefined") {
               return  y.toFixed(0) + "$";
             }
             return y;
             
           }
         }, {
           formatter: function (y) {
             if(typeof y !== "undefined") {
               return  y.toFixed(2) + "$";
             }
             return y;
             
           }},
           {
             formatter: function (y) {
               if(typeof y !== "undefined") {
                 return  y.toFixed(4) + "%";
               }
               return y;
               
             }
         }]
       },
       legend: {
         horizontalAlign: 'left',
         offsetX: 40
       }
       }
 
      
     
     
       });




      const [lineaMargen, setlineaMargen] = useState({
     
        options: {
          series: [
          ],
          chart: {
            height: 350,
            type: 'line',
            dropShadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2
            },
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false
            }
          },
          colors: ['#77B6EA', '#545454'],
          dataLabels: {
            enabled: false, 
            align: 'left',
           
          offsetX: 7,
          offsetY: 0,    
            formatter: function(val, opt) {
              return val.toFixed(0) + "%";
          },
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: 'Margenes',
            align: 'left'
          },
          grid: {
            show:false,
            borderColor: '#e7e7e7',
            align: 'left',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          markers: {
            size: 1
          },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  return  y.toFixed(0) + "%";
                }
                return y;
                
              }
            }
          },
          xaxis: {
            categories: ['2021', '2022', '2023','2024'],
            title: {
              text: 'Year'
            }
          },
          yaxis: {
            title: {
              text: '%'
            },
            gridLines: {
              drawBorder: false,
          },
            min: 0,
            max: 300,
            //forceNiceScale: true,
          },
      
          legend: {
            enabled:true,
            position: 'top',
            horizontalAlign: 'right',
            floating: true,
            offsetY: -25,
            offsetX: -5
          }
          
          }
        
     
      
      
        });

        



  const [ejemploChart3, setejemploChart3] = useState({
    name: "",
    color: "#2271b3",
    data: [],
  })
  
  const [ejemploOptionChart3, setEjemploOptionColumnChart3] = useState({
    chart: {
      type: "area",
      foreColor: "#adb0bb",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });

  


  const [ejemploChartMargen, setejemploChartMargen] = useState({
    name: "",
    color: "#87CEEB",
    data: [],
  })
  
  const [ejemploOptionChartMargen, setEjemploOptionColumnChartMargen] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
      
        dataLabels: {
          position: 'top', // top, center, bottom
        },
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "30%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });

  


  const [accumTotal, setAccumTotal] = useState({
    name: "",
    color: "#20603d",
    data: [],
  });
  const [accumTotalChart, setAccumTotalChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });

  const [optionChart1indice, setOptionChart1indice] = useState({
    name: "",
    color: "#20603d",
    data: [],
  });
  const [optionChart1, setOptionChart1] = useState({
    chart: {
      type: "area",
      foreColor: "#20603d",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });
  const [optionChart2, setOptionChart2] = useState({
    chart: {
      type: "area",
      foreColor: "#adb0bb",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });

  const [ejemploOptionTortaChart1, setEjemploTortaOptionChart] = useState({
        
    series: [],
    options: {
      chart: {
        width: 150,
        type: 'donut',
        color:'#252850'
      },
      colors: ['#252850', '#87CEEB'],
      tooltip: {
        fillSeriesColor: true,
      },
      total: {
        show: true
    },
      labels: ['utilidades','perdidas'],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'center'
          }
        }
      }]
    }
  })

const [ejemploRadial, setEjemploRadial] = useState({
        
  series: [90],
  options: {
  chart: {
    height: 350,
    type: 'radialBar',
    
},
title: {
  text: 'Crecimiento',
  //offsetX: 110
},
labels: ['2024'],
plotOptions: {
        radialBar: {
          hollow: {
            size: "70%",
          },
          total:{
            show: true,
          },
          value:{
            show: true,
          },
          dataLabels:{
            value:{
              show: true,
            },
          }
        },
      },
    }
  })




  const [ejemploRadial2, setEjemploRadial2] = useState({
        
    series: [90],
    options: {
    chart: {
      height: 350,
      type: 'radialBar',
  },
  title: {
    text: 'crecimiento',
    //offsetX: 110
  },
  labels: ['2024'],
  plotOptions: {
          radialBar: {
            hollow: {
              size: "70%",
            },
            total:{
              show: true,
            },
            value:{
              show: true,
            },
            dataLabels:{
              value:{
                show: true,
              },
            }
          },
        },
      }
    })







  const [optionChart, setOptionChart] = useState({
    chart: {
      type: "area",
      foreColor: "#adb0bb",
      toolbar: {
        show: false,
      },
      height: 60,
      sparkline: {
        enabled: true,
      },
      group: "sparklines",
    },
    stroke: {
      width: 1,
    },
    fill: {
      colors: "blue",
      type: "solid",
      opacity: 0.01,
    },
    markers: {
      size: 0,
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (value) => value.toFixed(2),
      },
    },
    xaxis: {},
  });

  const [optionColumnChartPrueba, setOptionColumnChartPrueba] = useState({
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: -100,
              to: -46,
              color: "#F15B46",
            },
            {
              from: -45,
              to: 0,
              color: "#FEB019",
            },
          ],
        },
        columnWidth: "80%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (y) {
          return y.toFixed(2);
        },
      },
    },
    xaxis: {},
  });

  const [chartRoaRoe, setChartRoaRoe] = useState({})

  const [chartCrecimiento, setChartCrecimiento] = useState({
    series: [],
    options: {
      chart: {
        height: 350,
        type: 'line',
        toolbar: {
          show: false,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
      },
    },
      stroke: {
        width: [0, 4]
      },
      grid: {
        show:false,
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        },
      },
      responsive: [
        {
          breakpoint: 1000,
          options: {
            plotOptions: {
              bar: {
                horizontal: false
              }
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ],
      markers: {
        size: 1
      },
      title: {
        text: 'Evolución ingresos'
      },
      dataLabels: {
        enabled: false,
        enabledOnSeries: [1],
        formatter: function(val, opt) {
          return val+"%"
      },
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: [{
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(0) + "$";
            }
            return y;
            
          }
        }, {
          formatter: function (y) {
            if(typeof y !== "undefined") {
              return  y.toFixed(2) + "%";
            }
            return y;
            
          }
        }]
        
      },
      labels: [],
      yaxis: [{
        title: {
          text: 'Ventas',
        },
      
      }, {
        opposite: true,
        title: {
          text: 'Crecimiento'
        }
      }]
      }
    })




    const [chartGastosAdm, setChartGastosAdm] = useState({
      series: [],
      options: {
        chart: {
          height: 350,
          stacked: true,
          color:'#e7e7e7',
          type: 'line',
        },
        dataLabels: {
          enabled: false,
          enabledOnSeries: [3],
        },
        stroke: {
          width: [1, 1, 1,2]
        },
        title: {
          text: 'Gastos adm',
          align: 'left',
          offsetX: 110
        },
        xaxis: {
          categories: [2009, 2010, 2011, 2012],
        },
        yaxis: [
          {
            seriesName: 'Income',
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#008FFB'
            },
            labels: {
              style: {
                colors: '#008FFB',
              }
            },
            title: {
              text: "Income (thousand crores)",
              style: {
                color: '#008FFB',
              }
            },
            tooltip: {
              enabled: true
            },
            min: 0,
            max: 3000000000

          },
          {
            seriesName: 'Cashflow',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#00E396'
            },
            labels: {
              style: {
                colors: '#00E396',
              }
            },
            title: {
              text: "Operating Cashflow (thousand crores)",
              style: {
                color: '#00E396',
              }
            },
          },
          {
            seriesName: 'Revenue',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#FEB019'
            },
            labels: {
              style: {
                colors: '#FEB019',
              },
            },
            title: {
              text: "Revenue (thousand crores)",
              style: {
                color: '#FEB019',
              }
            }
          },
        ],
        tooltip: {
          fixed: {
            enabled: true,
            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60
          },
        },
        legend: {
          horizontalAlign: 'left',
          offsetX: 40
        }
        }
      })



  const [dailyReturnC, setDailyReturnC] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnOnWinnersTotal, setReturnOnWinnersTotal] = useState(0);
  const [returnOnWinnersChart, setReturnOnWinnersChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnOnLosersTotal, setReturnOnLosersTotal] = useState(0);
  const [returnOnLosersChart, setReturnOnLosersChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnLongTotal, setReturnLongTotal] = useState(0);
  const [returnLongChart, setReturnLongChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [returnShortTotal, setReturnShortTotal] = useState(0);
  const [returnShortChart, setReturnShortChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [biggestProfitT, setBiggestProfitT] = useState(0);
  const [biggestLoseT, setBiggestLoseT] = useState(0);
  const [winLoseRatio, setWinLoseRatio] = useState(1);
  const [closedTradesTotal, setClosedTradesTotal] = useState(0);
  const [closedTradesChart, setClosedTradesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [openTradesTotal, setOpenTradesTotal] = useState(0);
  const [openTradesChart, setOpenTradesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [allTradesTotal, setAllTradesTotal] = useState(0);
  const [allTradesChart, setAllTradesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [avgNumTrades, setAvgNumTrades] = useState(0);
  const [totalWin, setTotalWin] = useState(0);
  const [totalLoss, setTotalLoss] = useState(0);
  const [totalWinChart, setTotalWinChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [totalLossChart, setTotalLossChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [beTotal, setBeTotal] = useState(0);
  const [totalBeChart, setTotalBeChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [openPercent, setOpenPercent] = useState(0);
  const [accumReturnPercentTotal, setAccumReturnPercentTotal] = useState(0);
  const [accumReturnPercentSeries, setAccumReturnPercentSeries] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [biggestPercentProfit, setBiggestPercentProfit] = useState(0);
  const [biggestPercentLose, setBiggestPercentLose] = useState(0);
  const [percentProfitsChart, setPercentProfitsChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [percentLosesChart, setPercentLosesChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });
  const [totalReturnNet, setTotalReturnNet] = useState(0);
  
  const [totalReturnNetChart, setTotalReturnNetChart] = useState({
    name: "",
    color: "#0094b6",
    data: [],
  });



  useEffect(() => {
   
    (async () => {
     
      setEstadoData(true);
      setIsLoading(true);
      dispatch(setReportsLoading());
      //7loading=true
      //alert("la var es "+loading)
      await axios
        .post("/api/get-reports_siigo", {
          userId,
          filters
        }
       
      
      
      )
        .then(
          (res) => {

          const {
            totalReturnY,
            totalReturnX,
            totalReturn,
            totalDates,
            dailyReturn,
            returnWin,
            returnWinTotal,
            returnLose,
            returnLoseTotal,
            returnLong,
            returnLongTotal,
            returnShort,
            returnShortTotal,
            biggestProfit,
            biggestLose,
            totalClosedTrades,
            closedTrades,
            totalOpenTrades,
            openTrades,
            totalTrades,
            dailyTrades,
            totalWinner,
            totalLoser,
            dailyWinners,
            dailyLosers,
            beCount,
            dailyBe,
            returnPercentSeries,
            returnPercentTotal,
            biggestPercentProfit,
            biggestPercentLose,
            percentProfits,
            percentLoses,
            totalReturnNet,
            totalReturnNetArray,
            saldo,
            detalle_ingresos,
            detalle_ingresos_año_anterior,
            detalle_costos,
            detalle_costos_año_anterior,
            detalle_gastos,
            detalle_gastos_año_anterior,
            lista_region_ventas,
            lista_asesor_ventas,
            costoV,
            costoM,
            utilidad,
            gastosAdmon,
            gastosPer,
            gastosHono,
            gastosImp,
            gastosArrend,
            gastosServ,
            gastosLegales,
            gastosViaje,
            gastosDiver,
            margenBruto,
            totalMargen,
            labels,
            crecimiento,
            margenOperacional,
            margenNeto,
            porcentCostVentas,
            gastosVentas,
            porcentCostGastos,
            crecimiento_ventas,
            crecimiento_ventas2,
            textoRadiaBarUltimo,
            textoRadiaBarAnterior,
            no_hay_data,
            max_saldo,
            max_gastosVentas,
            max_gastosAdmon,
            max_saldoCostos,
            roa,
            roe,
            labels_roaroe,
            total_ventas,
            total_costos,
            total_gastos,
            ebitdaTotal,
            texto_año,
            saldo_año_anterior,
            es_anual,
            año_actual,
            año_anterior,
            costos_año_anterior,
            listaSumaGastosVentasGastosAdmon,
            listaSumaGastosVentasGastosAdmonAñoAnterior,
            lista_periodo_promedio_cobranza,
            lista_periodo_promedio_pago,
            lista_periodo_promedio_inventario,
            lista_periodo_promedio_cobranza_año_anterior,
            lista_periodo_promedio_pago_año_anterior,
            lista_periodo_promedio_inventario_año_anterior,
            lista_ratio_liquidez,
            lista_prueba_acida,
            lista_capital_trabajo,
            lista_ratio_liquidez_año_anterior,
            lista_prueba_acida_año_anterior,
            lista_capital_trabajo_año_anterior,
            lista_endeudamiento,
            lista_apalancamiento,
            lista_endeudamiento_año_anterior,
            lista_apalancamiento_año_anterior,
            utilidad_neta_total
          } = res.data;
          //total_ventas=toMoney(total_ventas)
          var totalVentas=toMoney(total_ventas)
          var totalCostos=toMoney(total_costos)
          var totalGastos=toMoney(total_gastos)
          var utilidadNeta=toMoney(utilidad_neta_total)
          var textoAño=texto_año
          settotalUtilidadNeta(utilidadNeta)
          setTotalVentas(totalVentas)
          setTotalCostos(totalCostos)
          setTotalGastos(totalGastos)
          setTotalEbitda(ebitdaTotal)
          setTextoAño(textoAño)
          setIsLoading(false)
          dispatch(setTradesLoadingFinished());
          setEstadoData(no_hay_data);
          setEstadoAnual(es_anual)
          setRegionVentas(lista_region_ventas)
          //alert(Object.values(Object.values(ventas_regiones)))
          //dispatch(setReportsLoadingFinished());

          setejemploChart({
            ...ejemploChart1,
            data:saldo
          });

    setChartDataRegiones({
    ...ChartDataRegiones,
    series: Object.values(lista_region_ventas), // valores para cada segmento
    plotOptions: {
  pie: {
    expandOnClick: true,
    startAngle: 0,
    endAngle: 360
  }
},
    options:{
    labels: Object.keys(lista_region_ventas),
    stroke: {
      show: true,
      width: 2,
      colors: ['#fff']
    },
    plotOptions: {
      pie: {
        expandOnClick: true,
        offset: 10
      }
    },
    legend: {
      position: 'right',
      fontSize: '16px',
      itemMargin: { horizontal: 10, vertical: 8 }
    },
      title: {
          text: 'Ventas por region'
        },
    dataLabels: {
      enabled: true,
      style: { fontSize: '14px', fontWeight: 'bold' },
      formatter: (val) => `${val.toFixed(1)}%`
    },
    tooltip: {
        y: {
       formatter: function(value, opts) {
      const mySeries = Object.values(lista_region_ventas);

      const series = mySeries; // use the known series directly
      const total = series.reduce((a, b) => a + b, 0);
      const porcentaje = total === 0 ? 0 : (value / total) * 100;
      return `COP ${Number(value).toLocaleString('es-CO')} (${porcentaje.toFixed(1)}%)`;
    }

      }
    }
      }
  });

  setChartDataAsesores({
    ...ChartDataAsesores,
    series: Object.values(lista_asesor_ventas), // valores para cada segmento
    plotOptions: {
  pie: {
    expandOnClick: true,
    startAngle: 0,
    endAngle: 360
  }
},
    options:{
    labels: Object.keys(lista_asesor_ventas),
    stroke: {
      show: true,
      width: 2,
      colors: ['#fff']
    },
    plotOptions: {
      pie: {
        expandOnClick: true,
        offset: 10
      }
    },
    legend: {
      position: 'right',
      fontSize: '16px',
      itemMargin: { horizontal: 10, vertical: 8 }
    },
      title: {
          text: 'Ventas por asesor'
        },
    dataLabels: {
      enabled: true,
      style: { fontSize: '14px', fontWeight: 'bold' },
      formatter: (val) => `${val.toFixed(1)}%`
    },
    tooltip: {
        y: {
       formatter: function(value, opts) {
      const mySeries = Object.values(lista_asesor_ventas);

      const series = mySeries; // use the known series directly
      const total = series.reduce((a, b) => a + b, 0);
      const porcentaje = total === 0 ? 0 : (value / total) * 100;
      return `COP ${Number(value).toLocaleString('es-CO')} (${porcentaje.toFixed(1)}%)`;
    }

      }
    }
      }
  });


          setEjemploOptionColumnChart({
            ...ejemploOptionChart1,
            xaxis: {
              categories: ['enero-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']
            },
          });



          setOptionChart1({
            ...optionChart1,
            xaxis: {
              categories:[1]
               
            },
          });


          setejemploChart2({
            ...ejemploChart2,
          
            series: [{
              name: 'Net Profit',
              data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
            }, {
              name: 'Revenue',
              data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
            }, {
              name: 'Free Cash Flow',
              data: [35, 41, 36, 26, 45, 48, 52, 53, 41]
            }]
         
          }
        );


        setEjemploRadial({
          ...ejemploRadial,
    
          series:[crecimiento_ventas],
          color:'#14a072',
          options: {
            colors: ["#14a072"],
            chart: {
              height: 450,
              color:'#14a072',
              type: 'radialBar',
          },
          title: {
            text: '',
            //offsetX: 110
          },
          labels: [textoRadiaBarUltimo],
          plotOptions: {
          
                  radialBar: {
                    background:'#14a072',
                    hollow: {
                      color:'#14a072',
                      size: "50%",
                    },
                    total:{

                      color:'#14a072',
                      show: true,
                    },
                    value:{
                      color:'#14a072',

                      show: true,
                    },
                    dataLabels:{
                      color:'#14a072',
                      value:{
                        show: true,
                      },
                    },
                    fill: {
                      color: '#14a072',
                    }
                  },
                },
              }
         
       
        }
      );



      setEjemploRadial2({
        ...ejemploRadial2,
  
        series: [crecimiento_ventas2],
        options: {
        colors: ["#75d119"],
          chart: {
            height: 350,
            type: 'radialBar',
        },
        title: {
          text: 'Crecimiento',
          //offsetX: 110
        },
        labels: [textoRadiaBarAnterior],
        plotOptions: {
                radialBar: {
                  hollow: {
                    size: "50%",
                  },
                  total:{
                    show: true,
                  },
                  value:{
                    show: true,
                  },
                  dataLabels:{
                    value:{
                      show: true,
                    },
                  },
             
                },
              },
            }
       
     
      }
    );

          setEjemploOptionColumnChart2({
            ...ejemploOptionChart2,
            series: [{
              name: 'costo ventas',
               type: 'column',
              color:'#8b0000',
              data: costoV
            }, {
              name: 'costo materia prima',
              type: 'line',
              data: costoM
            }],
            xaxis: {
              categories: ['enero-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']
            },
          });


          setChartCrecimiento({
            ...chartCrecimiento,
            xaxis: {
              categories: ['enero-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']
            },
            series: [{
              name: 'Ventas',
              type: 'column',
              color:'#80448C',
              data: saldo,
              categories: ['2021', '2022', '2023', '2027']

            }, {
              name: 'Crecimiento',
              type: 'line',
              color: '#F7A741',
              curve: 'smooth',
              data: crecimiento,
              categories: ['2021', '2022', '2023', '2027']

            },
          ],

          options: {
            chart: {
              width:500,
              height:450,
              type: 'bar',
              toolbar: {
                show: false,
                offsetX: 0,
                offsetY: 0,
                tools: {
                  download: true,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true | '<img src="/static/icons/reset.png" width="20">',
                  customIcons: []
                },
            },
          },
          responsive: [
            {
              breakpoint: 1000,
              options: {
                plotOptions: {
                  bar: {
                  
                    horizontal: false
                  }
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ],
          plotOptions: {
            bar: {
            
             columnWidth: "38%",
            },
          },
            stroke: {
              width: [0, 4]
            },
            grid: {
              show:false,
              borderColor: '#e7e7e7',
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            markers: {
              size: 4
            },
            title: {
              text: 'Evolución Ingresos'
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: [1],
              formatter: function(val, opt) {
                return val+"%"
            },
            },
            tooltip: {
              shared: false,
              intersect: true,
              y: [{
                formatter: function (y) {
                  if(typeof y !== "undefined") {
                    y=toMoney(y)
                    return  y;
                  }
                  return y;
                  
                }
              }, {
                formatter: function (y) {
                  if(typeof y !== "undefined") {
                    return  y.toFixed(0) + "%";
                  }
                  return y;
                  
                }
              }]
              
            },
            xaxis:{
              labels: {
                style: {
                  fontSize: "9.95px",
                  
                },
              },
            },
            labels: labels,
            yaxis: [{
              min:0,
              max:saldo,
              labels: {
                show: false,
              },
              title: {
                text: '',
              },
            
            }, {
              opposite: true,
              labels: {
                show: false,
              },
              title: {
                text: ''
              }
            }] 
            }
        
          
          
         
          
          });

    
          setChartRoaRoe({
            ...chartRoaRoe,
          
            series: [{
              name: 'Roa',
              type: 'column',
              color:'#4C7081',
              data: roa,
              categories: ['2021', '2022', '2023', '2027']

            }, {
              name: 'Roe',
              type: 'column',
              color: '#ED6D3A',
              data: roe,
              categories: ['2021', '2022', '2023', '2027']

            },
          ],
        options :{
          chart: {
            width:500,
            height:250,
            stacked: true,
            type: 'bar',
            toolbar: {
              show: false,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
          },
        },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "45%",
          
            }
          },
          grid: {
            show:false,
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          title: {
            text: 'ROA vs ROE',
            //offsetX: 110
          },
          dataLabels: {
            enabled: false,
          
          },
          stroke: {
          
          },
          tooltip: {
            shared: false,
            intersect: true,
            y: [{
              
                formatter: function (y) {
                  if(typeof y !== "undefined") {
                    return  y.toFixed(0) + "%";
                  }
                  return y;
                  
                }
              },{
                formatter: function (y) {
                  if(typeof y !== "undefined") {
                    return  y.toFixed(0) + "%";
                  }
                  return y;
                  
                }
              


            }]
          },
          xaxis: {
            categories: labels_roaroe,
            fontSize: "1px",
            labels: {
              formatter: function(value) {
                 return value;    
          },

         
            style: {
              fontSize: "9.95px",
              
            },
              
          },

          labels: {
            style: {
              fontSize: "9.95px",
              
            },
          },
        }
          
      }
       
          
       /* 
          options: {
            chart: {
              width:500,
              height:450,
              type: 'bar',
              toolbar: {
                show: false,
                offsetX: 0,
                offsetY: 0,
                tools: {
                  download: true,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true | '<img src="/static/icons/reset.png" width="20">',
                  customIcons: []
                },
            },
          },
          responsive: [
            {
              breakpoint: 1000,
              options: {
                plotOptions: {
                  bar: {
                  
                    horizontal: true
                  }
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ],
          plotOptions: {
            bar: {
              horizontal: false,
             columnWidth: "55%",
            },
          },
            stroke: {
              width: [0, 0]
            },
            grid: {
              show:false,
              borderColor: '#e7e7e7',
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            markers: {
              size: 4
            },
            title: {
              text: 'Roa vs Roe'
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: [1],
              formatter: function(val, opt) {
                return val+"%"
            },
            },
            tooltip: {
              shared: false,
              intersect: true,
              y: [{
                formatter: function (y) {
                  if(typeof y !== "undefined") {
                    y=toMoney(y)
                    return  y;
                  }
                  
                }
              }, {
                formatter: function (y) {
                  if(typeof y !== "undefined") {
                    y=toMoney(y)
                    return  y;
                  }
                  
                }
              }]
              
            },
            labels: labels,
            yaxis: [] 
            }
        
          
          */
         
          
          });





          setChartGastosAdm({
            ...chartGastosAdm,
            series: [{
              name: 'Ventas',
              type: 'column',
              data: saldo
            }, 
            {
              name: 'costos ventas',
              type: 'column',
              data: costoV
            },
            {
              name: 'gastos adm y ventas',
              type: 'column',
              data: gastosAdmon
            },
            
            {
              name: 'Margen operacional',
              type: 'line',
              height: 350,
              curve: 'smooth',
              data: margenOperacional
            }],
            xaxis: {
              categories: ['2021', '2022', '2023', '2024']
            },
          });



          setejemplolinea({
            ...ejemplolinea,
            series: [
            {
              name: 'Costos ventas',
              type: 'column',
              color:'#00938b',
              data: costoV
            },
          //  {
            //  name: 'Ventas',
              //type: 'column',
              //color:'#80448C',
              //data: saldo
            //}, 
            {
              name: '% costos sobre ventas',
              type: 'line',
              color:'#F7A741',
              curve: 'smooth',
              data: porcentCostVentas
            },      
          ],
          options : {
            series: [
          ],
            chart: {
            height: 350,
            stacked: true,
            type: 'line',
            toolbar: {
              show: false,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
          },
          events: {
    dataPointSelection: function (event, chartContext, config) {
      alert("desde costos")
      const { seriesIndex, dataPointIndex, w } = config;
      const mes = w.globals.labels[dataPointIndex];
    
      
      if (dataPointIndex === -1) return;

      const series = chartContext.w.globals.series;
      const serieSeleccionada = w.config.series[seriesIndex];
      let detalle=[]
      if(serieSeleccionada.name=='2024'){
        detalle=detalle_costos}
      if(serieSeleccionada.name=='2023'){
        detalle=detalle_costos_año_anterior}

      const detalleHTML = buildDetalleHTML({
        w,
        series,
        dataPointIndex,
        detalle, // 👈 tu lista de diccionarios
      });

      abrirPopup(
  ` `,
  `
     <div style="display:flex; align-items:center; gap:8px;">
    <span style="font-size:20px;">📊</span>
    <span style="font-size:18px; font-weight:600; color:#3a0040;">
      Detalle de ingresos  ${serieSeleccionada.name}
      Mes ${mes}
    </span>
  </div>
    <div id="miniChartWrap" style="width:100%; max-width:100%; padding:8px 0">
      <div id="miniChart"></div>
    </div>
    ${detalleHTML}
  `
);


      setTimeout(() => renderMiniChart(series, dataPointIndex, detalle), 0);
    }
  },
        },
          dataLabels: {
            enabled: false
          },
          responsive: [
            {
              options: {
                xaxis: {
                  categories: [],
                  labels: {
                    style: {
                      fontSize: "9.5px",
                      
                    },
                  },
                },
                plotOptions: {
                  bar: {
                  
                    horizontal: true
                  }
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ],
          stroke: {
            curve: 'smooth',
           // width: [0, 0, 4]
            width: [0, 4]
          },
          grid: {
            show:false,
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          markers: {
            size: 5
          },
          plotOptions: {
            bar: {
     
              columnWidth: "37%",
            },
          },
          markers: {
            size: 5
          },
          title: {
            text: 'Evolución Costos',
            //offsetX: 110
          },
          xaxis: {
            categories: labels,
            labels: {
              style: {
                fontSize: "9.95px",
                
              },
            },
            
          },
          yaxis: [
          //  {
              
            //  min: 0,
              //max: max_saldoCostos,
              //forceNiceScale: true,
              //labels: {
                //show: false,
              //},
              //title: {
                //text: '',
              //},
            //},
            {
              //min: 0,
              //max: max_saldoCostos,
              forceNiceScale: true,
              labels: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },

            {
             
              forceNiceScale: true,
              opposite:true,
              labels: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
         
           
          ],
          tooltip: {
            shared: true,
            intersect: false,
            fixed: {
              enabled: true,
              position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
              offsetY: 30,
              offsetX: 60
            },
            y: [
              
              //{
              //formatter: function (y) {
                //if(typeof y !== "undefined") {
                  //y=toMoney(y)
                  //return  y;
                //}
                
              //}
            //}, 
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                
              }},
              {
                formatter: function (y) {
                  if(typeof y !== "undefined") {
                    return  y.toFixed(0) + "%";
                  }
                  
                }
            }]
          },
          legend: {
            horizontalAlign: 'left',
            offsetX: 40
          }
          }
    
         
      



      
      
          });




          setejemplolinea2({
            ...ejemplolinea2,
            series: [
              {
                name: 'Gastos ventas',
                type: 'column',
                color:'#F7A741',
                data: gastosVentas
              },
              {
                name: 'Gastos administracion',
                type: 'column',
                color:'#83BA43',
                data: gastosAdmon
              },
          
             // {
               // name: 'Ventas',
                //color:'#80448C',
                //type: 'column',
                //data: saldo
              //},
              {
                name: '% Gastos sobre ventas',
                type: 'line',
                color:'#FF4500',
                curve: 'smooth',
                data: porcentCostGastos
              },       
            
          ],

          options : {
            series: [
          ],
            chart: {
            height: 50,
            stacked: true,
            type: 'line',
            toolbar: {
             show: false,
             offsetX: 0,
             offsetY: 0,
             tools: {
               download: true,
               selection: true,
               zoom: true,
               zoomin: true,
               zoomout: true,
               pan: true,
               reset: true | '<img src="/static/icons/reset.png" width="20">',
               customIcons: []
             },
          },
         },
         responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 800
            },
            legend: {
              position: 'center'
            }
          }
        }],
        dataLabels: {
          formatter: (val) => {
            return val / 1000000 + 'K'
          }
        },
          stroke: {
            curve: 'smooth',
            //width: [1, 1, 1,4]
            width: [1, 1, 4]
          },
          plotOptions: {
           bar: {
             horizontal: false,
             dataLabels: {
               total: {
                 enabled: false,
                 offsetX: 0,
                 style: {
                   fontSize: '10px',
                   fontWeight: 800
                 }
               }
             },
             columnWidth: "37%",
           },
         },
          grid: {
            show:false,
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          markers: {
           size: 4
         },
          title: {
            text: 'Evolución Gastos',
            //offsetX: 110
          },
          xaxis: {
            categories: labels,
              labels: {
                style: {
                  fontSize: "9.95px",
                  
                },
              }
          },
          yaxis:[
       
           // {
          
            //forceNiceScale:true,
            //min:0,
            //max:max_saldo,
            //opposite:false,
            //labels: {
              //show: false,
            //},
            //title: {
              //text: '',
            //},
          
          //}, 
           {
            forceNiceScale:true,
            min:0,
            max:max_saldo,
            opposite:false,
            labels: {
              show: false,
            },
            title: {
              text: ''
            }
          },
          {
            forceNiceScale:true,
            min:0,
            max:max_saldo,
            opposite:false,
            labels: {
              show: false,
            },
            title: {
              text: ''
            }
          },


          {
            forceNiceScale:true,
            opposite:true,
            labels: {
              show: false,
            },
            title: {
              text: ''
            }
          }
       
            ] ,
          tooltip: {
            shared: true,
            intersect: false,
            fixed: {
              enabled: true,
              position: 'bottomLeft', // topRight, topLeft, bottomRight, bottomLeft
              offsetY: 30,
              offsetX: 60
            },
            y: [
              //{
              //formatter: function (y) {
                //if(typeof y !== "undefined") {
                  //y=toMoney(y)
                  //return  y;
                //}
                
              //}
             //}, 
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                
              }},
              {
                formatter: function (y) {
                  if(typeof y !== "undefined") {
                    y=toMoney(y)
                    return  y;
                  }
                  
                }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                
                  return  y.toFixed(0)+"%";
                }
                
              }}         
          ]
          },
          legend: {
            show: true,
        enabled:true,
        horizontalAlign: 'center',
        floating: false,
          }
          }    
      
          });

          setventasArea({
            ...ventasArea,
           series: [ {
          name: año_actual,
          color:'#80448C',
          data:saldo
        },
        ...(año_anterior !== '2020'
          ? [{
              name: año_anterior,
              color:'#F7A741',
              data: saldo_año_anterior,
          }]
          : []), // Si no es 2022, no se agrega la serie
      
      ],

        options : {
          series: [],
          chart: {
            toolbar: {
      show: false
    },
          events: {
    dataPointSelection: function (event, chartContext, config) {
      const { seriesIndex, dataPointIndex, w } = config;
      const mes = w.globals.labels[dataPointIndex];
    
      
      if (dataPointIndex === -1) return;

      const series = chartContext.w.globals.series;
      const serieSeleccionada = w.config.series[seriesIndex];
      const serieActual = w.config.series[0];
      let detalle=[]
      if(serieSeleccionada.name=='2026'){
        detalle=detalle_ingresos}
      if(serieSeleccionada.name=='2025'){
        detalle=detalle_ingresos}
      if(serieSeleccionada.name=='2024'){
        detalle=detalle_ingresos}
      if(serieActual.name=='2025' && serieSeleccionada.name=='2024'){
        detalle=detalle_ingresos_año_anterior}
      if(serieSeleccionada.name=='2023'){
        detalle=detalle_ingresos_año_anterior}
      if(serieActual.name=='2026' && serieSeleccionada.name=='2025'){
        detalle=detalle_ingresos_año_anterior}



      const detalleHTML = buildDetalleHTML({
        w,
        series,
        dataPointIndex,
        detalle, // 👈 tu lista de diccionarios
      });

      abrirPopup(
  ` `,
  `
     <div style="display:flex; align-items:center; gap:8px;">
    <span style="font-size:20px;">📊</span>
    <span style="font-size:18px; font-weight:600; color:#3a0040;">
      Detalle de ingresos  ${serieSeleccionada.name}
      Mes ${mes}
    </span>
  </div>
    <div id="miniChartWrap" style="width:100%; max-width:100%; padding:8px 0">
      <div id="miniChart"></div>
    </div>
    ${detalleHTML}
  `
);


      setTimeout(() => renderMiniChart(series, dataPointIndex, detalle), 0);
    }
  },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: labels,
        grid: {
          show:false,
          
        },
        title: {
          text: 'Evolución Ingresos'
        },
           markers: {
  size: 5,
  hover: {
    size: 7
  }
},
     tooltip: {
      shared: false,
            intersect: true,
            enabled: true ,
            y: [{
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            }
          
          
          ]
},
        yaxis: [{
       
          labels: {
            show: false,
          },
          title: {
            text: '',
          },
        
        }]
        },      
          });





          setcostosArea({
            ...costosArea,
           series: [ {
          name: año_actual,
          color:'#00938b',
          data:costoV
        },
        ...(año_anterior !== '2020'
          ? [{
              name: año_anterior,
              color:'#F7A741',
              data: costos_año_anterior,
          }]
          : []), // Si no es 2022, no se agrega la serie
      
      ],

        options : {
          series: [],
          chart: {
            toolbar: {
              show: false,
            },
          events: {
    dataPointSelection: function (event, chartContext, config) {
      const { seriesIndex, dataPointIndex, w } = config;
      const mes = w.globals.labels[dataPointIndex];
      
      if (dataPointIndex === -1) return;

      const series = chartContext.w.globals.series;
      const serieSeleccionada = w.config.series[seriesIndex];
      const serieActual = w.config.series[0];
      let detalle=[]
      if(serieSeleccionada.name=='2026'){
        detalle=detalle_costos}
      if(serieSeleccionada.name=='2025'){
        detalle=detalle_costos}
      if(serieSeleccionada.name=='2024'){
        detalle=detalle_costos}
      if(serieActual.name=='2025' && serieSeleccionada.name=='2024'){
        detalle=detalle_costos_año_anterior}
      if(serieSeleccionada.name=='2023'){
        detalle=detalle_costos_año_anterior}
      if(serieActual.name=='2026' && serieSeleccionada.name=='2025'){
        detalle=detalle_costos_año_anterior}

      const detalleHTML = buildDetalleHTML({
        w,
        series,
        dataPointIndex,
        detalle, // 👈 tu lista de diccionarios
      });

      abrirPopup(
  ` `,
  `
     <div style="display:flex; align-items:center; gap:8px;">
    <span style="font-size:20px;">📊</span>
    <span style="font-size:18px; font-weight:600; color:#3a0040;">
      Detalle de costos  ${serieSeleccionada.name}
      Mes ${mes}
    </span>
  </div>
    <div id="miniChartWrap" style="width:100%; max-width:100%; padding:8px 0">
      <div id="miniChart"></div>
    </div>
    ${detalleHTML}
  `
);


      setTimeout(() => renderMiniChart(series, dataPointIndex, detalle), 0);
    }
  },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: labels,
        grid: {
          show:false,
          
        },
        title: {
          text: 'Evolución Costos'
        },
        markers: {
                    size: 5,
                    hover: {
                      size: 7
                    }
                  },
        tooltip: {
            shared: false,
            intersect: true,
            enabled: true ,
            y: [{
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            }
          
          
          ]
        
        },
        yaxis: [{
       
          labels: {
            show: false,
          },
          title: {
            text: '',
          },
        
        }]
        },      
          });



          
          setgastosArea({
            ...gastosArea,
           series: [ {
          name: año_actual,
          color:'#83BA43',
          data:listaSumaGastosVentasGastosAdmon
        },
        ...(año_anterior !== '2020'
          ? [{
              name: año_anterior,
              color:'#F7A741',
              data: listaSumaGastosVentasGastosAdmonAñoAnterior,
          }]
          : []), // Si no es 2022, no se agrega la serie
      
      ],

        options : {
          series: [],
          markers: {
  size: 5,
  hover: {
    size: 7
  }
},

        chart: {
   toolbar: {
      show: false
    },
   events: {
    dataPointSelection: function (event, chartContext, config) {
      const { seriesIndex, dataPointIndex, w } = config;
      const mes = w.globals.labels[dataPointIndex];
    
      
      if (dataPointIndex === -1) return;

      const series = chartContext.w.globals.series;
      const serieSeleccionada = w.config.series[seriesIndex];
      const serieActual = w.config.series[0];
      let detalle=[]
      if(serieSeleccionada.name=='2026'){
        detalle=detalle_gastos}
      if(serieSeleccionada.name=='2025'){
        detalle=detalle_gastos}
      if(serieSeleccionada.name=='2024'){
        detalle=detalle_gastos}
      if(serieActual.name=='2025' && serieSeleccionada.name=='2024'){
        detalle=detalle_gastos_año_anterior}
      if(serieSeleccionada.name=='2023'){
        detalle=detalle_gastos_año_anterior}
      if(serieActual.name=='2026' && serieSeleccionada.name=='2025'){
        detalle=detalle_gastos_año_anterior}

      const detalleHTML = buildDetalleHTML({
        w,
        series,
        dataPointIndex,
        detalle, // 👈 tu lista de diccionarios
      });

      abrirPopup(
  ` `,
  `
     <div style="display:flex; align-items:center; gap:8px;">
    <span style="font-size:20px;">📊</span>
    <span style="font-size:18px; font-weight:600; color:#3a0040;">
      Detalle de gastos  ${serieSeleccionada.name}
      Mes ${mes}
    </span>
  </div>
    <div id="miniChartWrap" style="width:100%; max-width:100%; padding:8px 0">
      <div id="miniChart"></div>
    </div>
    ${detalleHTML}
  `
);


      setTimeout(() => renderMiniChart(series, dataPointIndex, detalle), 0);
    }
  }
},
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: labels,
        grid: {
          show:false,
          
        },
        title: {
          text: 'Evolución Gastos'
        },
         tooltip: {
     shared: false,
            intersect: true,
            enabled: true ,
            y: [{
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            }
          
          
          ]
},
        yaxis: [{
       
          labels: {
            show: false,
          },
          title: {
            text: '',
          },
        
        }]
        },      
          });




          setlineaMargen({
            ...lineaMargen,
            series: [
              {
                name: "Margen bruto",
                type: 'line',
                color:'#ced114',
                curve: 'straight',
                data: margenBruto
              },
              {
                name: "Margen operacional",
                type: 'line',
                color:'#14a072',
                curve: 'straight',
                data: margenOperacional
              },
              {
                name: "Margen neto",
                type: 'line',
                color:'#cf3e13',
                curve: 'straight',
                data: margenNeto
              }
            ],


            options: {
              series: [
              ],
              chart: {
                height: 350,
                type: 'line',
                dropShadow: {
                  enabled: true,
                  color: '#000',
                  top: 18,
                  left: 7,
                  blur: 10,
                  opacity: 0.2
                },
                zoom: {
                  enabled: false
                },
                toolbar: {
                  show: false
                }
              },
              colors: ['#77B6EA', '#545454'],
              dataLabels: {
                enabled: false, 
                align: 'left',
               
              offsetX: 7,
              offsetY: 0,    
                formatter: function(val, opt) {
                  return val.toFixed(0) + "%";
              },
              },
              stroke: {
                curve: 'smooth'
              },
              title: {
                text: 'Márgenes de Rentabilidad Operacional',
                align: 'left'
              },
              grid: {
                show:false,
                borderColor: '#e7e7e7',
                align: 'left',
                row: {
                  colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                  opacity: 0.5
                },
              },
              markers: {
                size: 5
              },
              tooltip: {
                shared: false,
                intersect: true,
                y: {
                  formatter: function (y) {
                    if(typeof y !== "undefined") {
                      return  y.toFixed(0) + "%";
                    }
                    return y;
                    
                  }
                }
              },
              xaxis: {
                categories: labels,
                labels: {
                  style: {
                    fontSize: "9.95px",
                    
                  },
                },
                title: {
                  text: ''
                }
              },
              yaxis: {
                labels: {
                  show: false,
                },
                title: {
                  text: ''
                },
                gridLines: {
                  drawBorder: false,
              },
             
              },
          
              legend: {
                enabled:true,
              
              }
              
              },
              yaxis: {
                labels: {
                  formatter: function (y) {
                    return y.toFixed(0);
                  },
                },
              },
      
      
          });

         
     setcobrosArea({
            ...cobrosArea,
           series: [ {
          name: año_actual,
          color:'#80448C',
          data:lista_periodo_promedio_cobranza
        },
        ...(año_anterior !== '2020'
          ? [{
              name: año_anterior,
              color:'#F7A741',
              data: lista_periodo_promedio_cobranza_año_anterior,
          }]
          : []), // Si no es 2022, no se agrega la serie
      
      ],

        options : {
          series: [],
          chart: {
            toolbar: {
      show: false
    },
          events: {
     },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: labels,
        grid: {
          show:false,
          
        },
        title: {
          text: 'Período promedio de cobranza'
        },
           markers: {
  size: 5,
  hover: {
    size: 7
  }
},
     tooltip: {
      shared: false,
            intersect: true,
            enabled: true ,
            y: [{
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  //y=toMoney(y)
                  return  y.toFixed(0) + " dias";
                }
                return y;
                
              }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  //y=toMoney(y)
                  return  y.toFixed(0) + " dias";
                }
                return y;
                
              }
            }
          
          
          ],
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
    const valor = series[seriesIndex][dataPointIndex];
    const nombreSerie = w.globals.seriesNames[seriesIndex];
    const label = w.globals.labels[dataPointIndex];

    return `
      <div style="padding:10px; font-size:12px;">
        <strong>${label}</strong><br/>
        ${nombreSerie}: ${valor.toFixed(0)} días
        <hr style="margin:5px 0;" />
        <span style="color:#666;">
          Este indicador muestra el tiempo promedio que tarda la empresa en cobrar a sus clientes.
        </span>
      </div>
    `;
  }
},
        yaxis: [{
       
          labels: {
            show: false,
          },
          title: {
            text: '',
          },
        
        }]
        },      
          });

              setpagosArea({
            ...pagosArea,
           series: [ {
          name: año_actual,
          color:'#00938b',
          data:lista_periodo_promedio_pago
        },
        ...(año_anterior !== '2020'
          ? [{
              name: año_anterior,
              color:'#F7A741',
              data: lista_periodo_promedio_pago_año_anterior,
          }]
          : []), // Si no es 2022, no se agrega la serie
      
      ],

        options : {
          series: [],
          chart: {
            toolbar: {
      show: false
    },
          events: {
     },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: labels,
        grid: {
          show:false,
          
        },
        title: {
          text: 'Período promedio de pago'
        },
           markers: {
  size: 5,
  hover: {
    size: 7
  }
},
     tooltip: {
      shared: false,
            intersect: true,
            enabled: true ,
            y: [{
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  return  y.toFixed(0) + " dias";
                }
                return y;
                
              }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                 return  y.toFixed(0) + " dias";

                }
                return y;
                
              }
            }
          
          
          ],
             custom: function({ series, seriesIndex, dataPointIndex, w }) {
    const valor = series[seriesIndex][dataPointIndex];
    const nombreSerie = w.globals.seriesNames[seriesIndex];
    const label = w.globals.labels[dataPointIndex];

    return `
      <div style="padding:10px; font-size:12px;">
        <strong>${label}</strong><br/>
        ${nombreSerie}: ${valor.toFixed(0)} días
        <hr style="margin:5px 0;" />
        <span style="color:#666;">
         Este indicador muestra cuántos días en promedio tarda una empresa en pagar a sus proveedores.
        </span>
      </div>
    `;
  }
          
},
        yaxis: [{
       
          labels: {
            show: false,
          },
          title: {
            text: '',
          },
        
        }]
        },      
          });

      setinventarioArea({
            ...inventarioArea,
           series: [ {
          name: año_actual,
          color:'#83BA43',
          data:lista_periodo_promedio_inventario
        },
        ...(año_anterior !== '2020'
          ? [{
              name: año_anterior,
              color:'#F7A741',
              data: lista_periodo_promedio_inventario_año_anterior,
          }]
          : []), // Si no es 2022, no se agrega la serie
      
      ],

        options : {
          series: [],
          chart: {
            toolbar: {
      show: false
    },
          events: {
     },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: labels,
        grid: {
          show:false,
          
        },
        title: {
          text: 'Rotación del inventario'
        },
           markers: {
  size: 5,
  hover: {
    size: 7
  }
},
     tooltip: {
      shared: false,
            intersect: true,
            enabled: true ,
            y: [{
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  //y=toMoney(y)
                  return  y.toFixed(0) + " dias";
                }
                return y;
                
              }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  //y=toMoney(y)
                  return  y.toFixed(0) + " dias";
                }
                return y;
                
              }
            }
          
          
          ],
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
    const valor = series[seriesIndex][dataPointIndex];
    const nombreSerie = w.globals.seriesNames[seriesIndex];
    const label = w.globals.labels[dataPointIndex];

    return `
      <div style="padding:10px; font-size:12px;">
        <strong>${label}</strong><br/>
        ${nombreSerie}: ${valor.toFixed(0)} días
        <hr style="margin:5px 0;" />
        <span style="color:#666;">
        Este indicador mide cuántas cuantas veces una empresa vende y repone su inventario en un período.
        </span>
      </div>
    `;
  }
},
        yaxis: [{
       
          labels: {
            show: false,
          },
          title: {
            text: '',
          },
        
        }]
        },      
          });


   setliquidezArea({
            ...liquidezArea,
           series: [ {
          name: año_actual,
          color:'#83BA43',
          data:lista_ratio_liquidez
        },
        ...(año_anterior !== '2020'
          ? [{
              name: año_anterior,
              color:'#F7A741',
              data: lista_ratio_liquidez_año_anterior,
          }]
          : []), // Si no es 2022, no se agrega la serie
      
      ],

        options : {
          series: [],
          chart: {
            toolbar: {
      show: false
    },
          events: {
     },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: labels,
        grid: {
          show:false,
          
        },
        title: {
          text: 'Ratio liquidez'
        },
           markers: {
  size: 5,
  hover: {
    size: 7
  }
},
     tooltip: {
      shared: false,
            intersect: true,
            enabled: true ,
            y: [{
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            }
          
          
          ],
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
    const valor = series[seriesIndex][dataPointIndex];
    const nombreSerie = w.globals.seriesNames[seriesIndex];
    const label = w.globals.labels[dataPointIndex];

    return `
      <div style="padding:10px; font-size:12px;">
        <strong>${label}</strong><br/>
        ${nombreSerie}: ${valor.toFixed(0)} días
        <hr style="margin:5px 0;" />
        <span style="color:#666;">
        Este indicador mide la capacidad de la empresa para pagar sus deudas de corto plazo.
        </span>
      </div>
    `;
  }
},
        yaxis: [{
       
          labels: {
            show: false,
          },
          title: {
            text: '',
          },
        
        }]
        },      
          });

           setpruebaacidaArea({
            ...pruebaacida,
           series: [ {
          name: año_actual,
          color:'#83BA43',
          data:lista_prueba_acida
        },
        ...(año_anterior !== '2020'
          ? [{
              name: año_anterior,
              color:'#F7A741',
              data: lista_prueba_acida_año_anterior,
          }]
          : []), // Si no es 2022, no se agrega la serie
      
      ],

        options : {
          series: [],
          chart: {
            toolbar: {
      show: false
    },
          events: {
     },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: labels,
        grid: {
          show:false,
          
        },
        title: {
          text: 'Prueba ácida'
        },
           markers: {
  size: 5,
  hover: {
    size: 7
  }
},
     tooltip: {
      shared: false,
            intersect: true,
            enabled: true ,
            y: [{
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            }
          
          
          ],
           custom: function({ series, seriesIndex, dataPointIndex, w }) {
    const valor = series[seriesIndex][dataPointIndex];
    const nombreSerie = w.globals.seriesNames[seriesIndex];
    const label = w.globals.labels[dataPointIndex];

    return `
      <div style="padding:10px; font-size:12px;">
        <strong>${label}</strong><br/>
        ${nombreSerie}: ${valor.toFixed(0)} días
        <hr style="margin:5px 0;" />
        <span style="color:#666;">
        Este indicador mide la capacidad de la empresa para pagar sus deudas de corto plazo sin depender del inventario.
        </span>
      </div>
    `;
  }
},
        yaxis: [{
       
          labels: {
            show: false,
          },
          title: {
            text: '',
          },
        
        }]
        },      
          });

setcapitaltrabajoArea({
            ...capitaltrabajo,
           series: [ {
          name: año_actual,
          color:'#83BA43',
          data:lista_capital_trabajo
        },
        ...(año_anterior !== '2020'
          ? [{
              name: año_anterior,
              color:'#F7A741',
              data: lista_capital_trabajo_año_anterior,
          }]
          : []), // Si no es 2022, no se agrega la serie
      
      ],

        options : {
          series: [],
          chart: {
            toolbar: {
      show: false
    },
          events: {
     },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: labels,
        grid: {
          show:false,
          
        },
        title: {
          text: 'Capital trabajo'
        },
           markers: {
  size: 5,
  hover: {
    size: 7
  }
},
     tooltip: {
      shared: false,
            intersect: true,
            enabled: true ,
            y: [{
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  y=toMoney(y)
                  return  y;
                }
                return y;
                
              }
            }
          
          
          ],
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
    const valor = series[seriesIndex][dataPointIndex];
    const nombreSerie = w.globals.seriesNames[seriesIndex];
    const label = w.globals.labels[dataPointIndex];

    return `
      <div style="padding:10px; font-size:12px;">
        <strong>${label}</strong><br/>
        ${nombreSerie}: ${valor.toFixed(0)} días
        <hr style="margin:5px 0;" />
        <span style="color:#666;">
        El capital de trabajo representa los recursos disponibles para la operación diaria de la empresa. Un valor positivo indica capacidad para cubrir obligaciones de corto plazo; negativo señala riesgo de liquidez.
        </span>
      </div>
    `;
  }
},
        yaxis: [{
       
          labels: {
            show: false,
          },
          title: {
            text: '',
          },
        
        }]
        },      
          });

setendeudamientoArea({
            ...endeudamientoArea,
           series: [ {
          name: año_actual,
          color:'#83BA43',
          data:lista_endeudamiento
        },
        ...(año_anterior !== '2020'
          ? [{
              name: año_anterior,
              color:'#F7A741',
              data: lista_endeudamiento_año_anterior,
          }]
          : []), // Si no es 2022, no se agrega la serie
      
      ],

        options : {
          series: [],
          chart: {
            toolbar: {
      show: false
    },
          events: {
     },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: labels,
        grid: {
          show:false,
          
        },
        title: {
          text: 'Endeudamiento'
        },
           markers: {
  size: 5,
  hover: {
    size: 7
  }
},
     tooltip: {
      shared: false,
            intersect: true,
            enabled: true ,
            y: [{
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  
                  return  y.toFixed(2);
                }
                return y;
                
              }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  
                  return  y.toFixed(2);
                }
                return y;
                
              }
            }
          
          
          ],
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
    const valor = series[seriesIndex][dataPointIndex];
    const nombreSerie = w.globals.seriesNames[seriesIndex];
    const label = w.globals.labels[dataPointIndex];

    return `
      <div style="padding:10px; font-size:12px;">
        <strong>${label}</strong><br/>
        ${nombreSerie}: ${valor.toFixed(0)} días
        <hr style="margin:5px 0;" />
        <span style="color:#666;">
        Este indicador mide que proporción de los activos de una empresa está financiada con deuda.
        </span>
      </div>
    `;
  }
},
        yaxis: [{
       
          labels: {
            show: false,
          },
          title: {
            text: '',
          },
        
        }]
        },      
          });


setapalancamientoArea({
            ...apalancamientoArea,
           series: [ {
          name: año_actual,
          color:'#83BA43',
          data:lista_apalancamiento
        },
        ...(año_anterior !== '2020'
          ? [{
              name: año_anterior,
              color:'#F7A741',
              data: lista_apalancamiento_año_anterior,
          }]
          : []), // Si no es 2022, no se agrega la serie
      
      ],

        options : {
          series: [],
          chart: {
            toolbar: {
      show: false
    },
          events: {
     },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        labels: labels,
        grid: {
          show:false,
          
        },
        title: {
          text: 'Apalancamiento financiero'
        },
           markers: {
  size: 5,
  hover: {
    size: 7
  }
},
     tooltip: {
      shared: false,
            intersect: true,
            enabled: true ,
            y: [{
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  
                  return  y.toFixed(2);
                }
                return y;
                
              }
            },
            {
              formatter: function (y) {
                if(typeof y !== "undefined") {
                  //y=toMoney(y)
                  return  y.toFixed(2);
                }
                return y;
                
              }
            }
          
          
          ],
             custom: function({ series, seriesIndex, dataPointIndex, w }) {
    const valor = series[seriesIndex][dataPointIndex];
    const nombreSerie = w.globals.seriesNames[seriesIndex];
    const label = w.globals.labels[dataPointIndex];

    return `
      <div style="padding:10px; font-size:12px;">
        <strong>${label}</strong><br/>
        ${nombreSerie}: ${valor.toFixed(0)} días
        <hr style="margin:5px 0;" />
        <span style="color:#666;">
        Es un indicador que mide qué tanto una empresa utiliza deuda (préstamos) para financiar sus operaciones y activos.
        </span>
      </div>
    `;
  }
},
        yaxis: [{
       
          labels: {
            show: false,
          },
          title: {
            text: '',
          },
        
        }]
        },      
          });


          setEjemploOptionColumnChart4({
            ...ejemploOptionChart4,
            series: [{
              name: 'gastos administración',
              data: gastosAdmon
            }, {
              name: 'gastos personal',
              data: gastosPer
            },
            {
              name: 'honorarios',
              data: gastosHono
            },
            
            {
              name: 'impuestos',
              data: gastosImp
            },
            {
              name: 'arrendamientos',
              data: gastosArrend
            },
            {
              name: 'servicios',
              type: 'column',
              data: gastosServ
            },
            {
              name: 'gastos legales',
              data: gastosLegales
            },
            {
              name: 'gastos de viaje',
              data: gastosViaje
            },
            {
              name: 'gastos diversos',
              data: gastosDiver
            }         
          ],
            xaxis: {
              categories: ['ese-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']
            },
          });



          setejemploChart3({
            ...ejemploChart3,
            data:utilidad
          });
          setOptionChart1indice({
          ...optionChart1indice,
          data:[44]
        });
          setEjemploOptionColumnChart3({
            ...ejemploOptionChart3,
            xaxis: {
              categories: ['enero-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']
            },
          });


          setejemploChartMargen({
            ...ejemploChartMargen,
            data:margenBruto
          });

          setEjemploOptionColumnChartMargen({
            ...ejemploOptionChartMargen,
            xaxis: {
              categories: ['enero-marzo', 'marzo-junio', 'junio-septiembre', 'septiembre-diciembre']
            },
          });
          
       
          
          setEjemploTortaOptionChart({
            ...ejemploOptionTortaChart1,
            series: [1, 2],
            labels: ["utilidad","perdidas"]
          });


          setAccumTotalChart({
            ...accumTotalChart,
            data:
              totalReturnY.length > 100
                ? arrayFilter(totalReturnY, 100)
                : totalReturnY,
          });
          setOptionColumnChart({
            ...optionColumnChart,
            xaxis: {
              categories:
                totalReturnX.length > 100
                  ? arrayFilter(totalReturnX, 100)
                  : totalReturnX,
            },
          });
          setOptionChart1({
            ...optionChart1,
            xaxis: {
              categories:
                totalReturnX.length > 200
                  ? arrayFilter(totalReturnX, 200)
                  : totalReturnX,
            },
          });
          setDailyReturnC({
            ...dailyReturnC,
            data:
              dailyReturn.length > 200
                ? arrayFilter(dailyReturn, 200)
                : dailyReturn,
          });
          setOptionChart2({
            ...optionChart2,
            xaxis: {
              categories:
                totalDates.length > 200
                  ? arrayFilter(totalDates, 200)
                  : totalDates,
            },
          });
          setReturnOnWinnersTotal(returnWinTotal);
          setReturnOnWinnersChart({
            ...returnOnWinnersChart,
            data:
              returnWin.length > 200 ? arrayFilter(returnWin, 200) : returnWin,
          });
          setReturnOnLosersTotal(returnLoseTotal);
          setReturnOnLosersChart({
            ...returnOnLosersChart,
            data:
              returnLose.length > 200
                ? arrayFilter(returnLose, 200)
                : returnLose,
          });
          setReturnLongTotal(returnLongTotal);
          setReturnLongChart({
            ...returnLongChart,
            data:
              returnLong.length > 200
                ? arrayFilter(returnLong, 200)
                : returnLong,
          });
          setReturnShortTotal(returnShortTotal);
          setReturnShortChart({
            ...returnShortChart,
            data:
              returnShort.length > 200
                ? arrayFilter(returnShort, 200)
                : returnShort,
          });
          setBiggestProfitT(biggestProfit);
          setBiggestLoseT(biggestLose);
          setWinLoseRatio(returnWin.length / returnLose.length);
          setClosedTradesTotal(totalClosedTrades);
          setAllTradesTotal(totalTrades);
          setOpenTradesTotal(totalOpenTrades);
          setClosedTradesChart({
            ...closedTradesChart,
            data:
              closedTrades.length > 200
                ? arrayFilter(closedTrades, 200)
                : closedTrades,
          });
          setAllTradesChart({
            ...allTradesChart,
            data:
              dailyTrades.length > 200
                ? arrayFilter(dailyTrades, 200)
                : dailyTrades,
          });
          setOpenTradesChart({
            ...openTradesChart,
            data:
              openTrades.length > 200
                ? arrayFilter(openTrades, 200)
                : openTrades,
          });
          setAvgNumTrades(totalTrades / totalDates.length);
          setTotalWin(totalWinner);
          setTotalWinChart({
            ...totalWinChart,
            data:
              dailyWinners.length > 200
                ? arrayFilter(dailyWinners, 200)
                : dailyWinners,
          });
          setTotalLoss(totalLoser);
          setTotalLossChart({
            ...totalLossChart,
            data:
              dailyLosers.length > 200
                ? arrayFilter(dailyLosers, 200)
                : dailyLosers,
          });
          setBeTotal((beCount * 100) / totalTrades);
          setTotalBeChart({
            ...totalBeChart,
            data: dailyBe.length > 200 ? arrayFilter(dailyBe, 200) : dailyBe,
          });
          setOpenPercent((totalOpenTrades * 100) / totalTrades);
          setAccumReturnPercentTotal(returnPercentTotal);
          setAccumReturnPercentSeries({
            ...accumReturnPercentSeries,
            data:
              returnPercentSeries.length > 100
                ? arrayFilter(returnPercentSeries, 100)
                : returnPercentSeries,
          });
          setBiggestPercentProfit(biggestPercentProfit);
          setBiggestPercentLose(biggestPercentLose);
          setPercentProfitsChart({
            ...percentProfitsChart,
            data:
              percentProfits.length > 100
                ? arrayFilter(percentProfits, 100)
                : percentProfits,
          });
          setPercentLosesChart({
            ...percentLosesChart,
            data:
              percentLoses.length > 100
                ? arrayFilter(percentLoses, 100)
                : percentLoses,
          });
          setTotalReturnNet(totalReturnNet);
          setTotalReturnNetChart({
            ...totalReturnNetChart,
            data:
              totalReturnNetArray.length > 0
                ? arrayFilter(totalReturnNetArray, 100)
                : totalReturnNetArray,
          });
         // setIsLoading(false);
          dispatch(setTradesLoadingFinished());


        })
        .catch((err) => console.log("esto es "+err));
    //  setIsLoading(false);
    })();
  }, [selected, filters]);

  

if(isLoading){

return  ( <Stack width="100%" justifyContent="center" alignItems="center">
     
<Spinner/>
<Typography variant="h5" sx={{ color: '#0094b6' }}>Please wait</Typography>
</Stack>)

  }
else{
  if(EstadoData){
    enqueueSnackbar("No data to display here", {
      variant: "warning",
    });
      }
if(tabValue==0){
  return (

    <Stack>
      {/*
      {isLoading? (
        <Stack width="100%" justifyContent="center" alignItems="center">
          <Spinner /> */}

{EstadoData? (
    <Fade in={true} timeout={3600}>
    <Paper sx={{ width: "100%", mb: 2 }}>
      <Stack py={10} alignItems="center" color="text.disabled">
        <TextSnippetIcon sx={{ fontSize: 120 }} />
        <Typography variant="h4">No data to display</Typography>
      </Stack>
    </Paper>
  </Fade>
    ):(

      
        <Grid container spacing={{ xs: 0, md: -5 }}>

       
        <Grid  item xs={12} md={6} lg={3} mx={0} sx={{ my:-2.5,
        // Ajusta los tamaños según el breakpoint
        width: '100%'
      }}>
            <Paper sx={{ p: 2 }} style={{ borderRadius: 40 / 2 ,width:'50%',height:'45%'}} >
              <Typography style={{ color: '#3a0040' }}>{'Ventas '}{textoAño}</Typography>
              <Typography variant="h5"   mb={1}  sx={{
    fontSize: {
      xs: '1rem',  // Para pantallas extra pequeñas
      sm: '0.2rem', // Para pantallas pequeñas
      md: '0.2rem',   // Para pantallas medianas
      lg: '0.8rem', // Para pantallas grandes
      xl: '1rem'    // Para pantallas extra grandes
    },
    color: '#2271b3', // Color del texto
    textAlign: 'center', // Alineación del texto
  }}
       >
                <b style={{ color: '#3a0040' }}>{totalVentas}</b>
              </Typography>
              {/*
              <Chart
                options={chartCrecimiento.options}
                series={[chartCrecimiento.series]}
                type="area"
                sx={3}
                height={25}
                color="#FEB019"
                style={{ marginTop: '-14px' }}
              />*/}
            </Paper>
          </Grid>


          <Grid sx={{mx:-15,my:-2.5  }} item xs={12} md={6} lg={3} mx={0} >
            <Paper sx={{ p: 2 }} style={{ borderRadius: 40 / 2 ,width:'50%',height:'45%'}}>
              <Typography style={{ color: '#3a0040' }}>{'Costos '}{textoAño}</Typography>
              <Typography variant="h5" mb={1} sx={{
    fontSize: {
      xs: '1rem',  // Para pantallas extra pequeñas
      sm: '0.2rem', // Para pantallas pequeñas
      md: '0.2rem',   // Para pantallas medianas
      lg: '0.8rem', // Para pantallas grandes
      xl: '1rem'    // Para pantallas extra grandes
    },
    color: '#2271b3', // Color del texto
    textAlign: 'center', // Alineación del texto
  }}>
                <b style={{ color: '#3a0040' }}>{totalCostos}</b>
              </Typography>
              {/*
              <Chart
                options={ejemploOptionChart3}
                series={[ejemploChart3]}
                type="area"
                height={20}
                color="#FEB019"
                style={{ marginTop: '-14px' }}
              />*/}
            </Paper>
          </Grid>


          <Grid sx={{mx:0,my:-2.5  }} item xs={12} md={6} lg={3} mx={0}  >
            <Paper sx={{ p: 2 }} style={{ borderRadius: 40 / 2 ,width:'50%',height:'45%'}}>
              <Typography style={{ color: '#3a0040' }}>{'Gastos '}{textoAño}</Typography>
              <Typography variant="h5" mb={1} sx={{
    fontSize: {
      xs: '1rem',  // Para pantallas extra pequeñas
      sm: '0.2rem', // Para pantallas pequeñas
      md: '0.2rem',   // Para pantallas medianas
      lg: '0.8rem', // Para pantallas grandes
      xl: '1rem'    // Para pantallas extra grandes
    },
    color: '#2271b3', // Color del texto
    textAlign: 'center', // Alineación del texto
  }}>
                <b style={{ color: '#3a0040' }}>{totalGastos}</b>
              </Typography>
              {/*
              <Chart
                options={ejemploOptionChart3}
                series={[ejemploChart3]}
                type="area"
                height={20}
                color="#FEB019"
                style={{ marginTop: '-14px' }}
              />*/}
            </Paper>
          </Grid>

          <Grid sx={{mx:-15,my:-2.5  }} item xs={12} md={6} lg={3} mx={0}  >
            <Paper sx={{ p: 2 }} style={{ borderRadius: 40 / 2 ,width:'50%',height:'45%'}}>
              <Typography style={{ color: '#3a0040' }}>{'EBITDA '}{textoAño}</Typography>
              <Typography variant="h5" mb={1} sx={{
    fontSize: {
      xs: '1rem',  // Para pantallas extra pequeñas
      sm: '0.2rem', // Para pantallas pequeñas
      md: '0.2rem',   // Para pantallas medianas
      lg: '0.8rem', // Para pantallas grandes
      xl: '1rem'    // Para pantallas extra grandes
    },
    color: '#2271b3', // Color del texto
    textAlign: 'center', // Alineación del texto
  }}>
                <b style={{ color: '#3a0040' }}>{totalEbitda}{'%'}</b>
              </Typography>
              {/*
              <Chart
                options={ejemploOptionChart3}
                series={[ejemploChart3]}
                type="area"
                height={20}
                color="#FEB019"
                style={{ marginTop: '-14px' }}
              />*/}
            </Paper>
          </Grid>
       <Grid sx={{mx:1,my:-2.5  }} item xs={12} md={6} lg={3} mx={0}  >
            <Paper sx={{ p: 2 }} style={{ borderRadius: 40 / 2 ,width:'50%',height:'45%'}}>
              <Typography style={{ color: '#3a0040' }}>{'Utilidad neta '}{textoAño}</Typography>
              <Typography variant="h5" mb={1} sx={{
    fontSize: {
      xs: '1rem',  // Para pantallas extra pequeñas
      sm: '0.2rem', // Para pantallas pequeñas
      md: '0.2rem',   // Para pantallas medianas
      lg: '0.8rem', // Para pantallas grandes
      xl: '1rem'    // Para pantallas extra grandes
    },
    color: '#2271b3', // Color del texto
    textAlign: 'center', // Alineación del texto
  }}>
                <b style={{ color: '#3a0040' }}>{totalUtilidadNeta}</b>
              </Typography>
              {/*
              <Chart
                options={ejemploOptionChart3}
                series={[ejemploChart3]}
                type="area"
                height={20}
                color="#FEB019"
                style={{ marginTop: '-14px' }}
              />*/}
            </Paper>
          </Grid>
   {/*
          
          <Grid  item xs={25} md={16} lg={3} mx={-15}>
            <Paper sx={{ p: 2 }} style={{ borderRadius: 40 / 2,width:'50%',height:'80%' }}>
              <Typography style={{ color: '#2271b3' }}>Utilidad neta</Typography>
              <Typography variant="h5" mb={1}>
                <b style={{ color: '#2271b3' }}>{accumTotal.toFixed(2)}</b>
              </Typography>
              <Chart
                options={ejemploOptionChart3}
                series={[ejemploChart3]}
                type="area"
                height={50}
                color="#FEB019"
              />
            </Paper>
          </Grid>
  */}
       {EstadoAnual? (
             <Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={chartCrecimiento
              .options} series={chartCrecimiento.series} type="line" 
              height="132%"
              />

            </Paper>
            </Grid>
       ):(
            <Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={ventasArea
              .options} series={ventasArea.series} type="area" 
              height="132%"
              />

            </Paper>
            </Grid>

              )
            }
     {EstadoAnual? (
            <Grid sx={{mx: 1,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 0 }} >
              <Typography variant="subtitle1"></Typography>
              <Chart options={ejemplolinea.options} series={ejemplolinea.series} type="line"  height="142%"/>

            </Paper>
            </Grid>

     ):(
            <Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={costosArea
              .options} series={costosArea.series} type="area" 
              height="132%"
              />

            </Paper>
            </Grid>
     )
    }

{/*
            
     <Grid  sx={{mx: 0  }} style={{width:'28%'}}>
       <Paper sx={{ p: 0 }} >
              <Typography variant="subtitle1"></Typography>
         
         <Chart options={ejemploRadial.options} series={ejemploRadial.series} type="radialBar"  height="142%"  />
       </Paper>
       </Grid>

*/}
      
       {/*
            <Grid  sx={{ mx: -4, my: -4 }}>
         
           
         <Chart options={ejemploRadial.options} series={ejemploRadial.series} type="radialBar"  height={200} width="200" />

       </Grid>

      */}
      

      {/*
       <Grid  sx={{ mx: -4, my: -4 }}>
         
           
         <Chart options={ejemploRadial.options} series={ejemploRadial.series} type="radialBar"  height={200} width="200" />

       </Grid> */}
   
          
       {/*


          <Grid item xs={22} md={6} lg={3} mx={-47}>
            <Paper sx={{ p: 1 }} style={{ borderRadius: 40 / 2,width:'60%' }}>
              <Typography variant="subtitle1">% ganancias</Typography>
              <Divider sx={{ mx: -1, my: 1 }} />
              <Chart options={ejemploOptionTortaChart1.options} series={ejemploOptionTortaChart1.series} type="donut"  height={280} width="280" />

            </Paper>
          </Grid>*/}
{/*
<Grid >
       <Paper sx={{ p: 1 }} >
              <Typography variant="subtitle1"></Typography>
         
         <Chart options={ejemploRadial2.options} series={ejemploRadial2.series} type="radialBar"  height={215} width="280" />
       </Paper>
       </Grid> */}
 {EstadoAnual? (
       <Grid sx={{mx: 0, my: 2  }} style={{width:'32%'}}>
            <Paper sx={{ p: 1 }} >
              <Typography variant="subtitle1"></Typography>
              <Chart options={ejemplolinea2.options} series={ejemplolinea2.series} type="line"  height="130%"  />

            </Paper>
            </Grid>
 ):(

  <Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
  <Paper sx={{ p: 1 }}>
    <Typography variant="subtitle1"></Typography>
    <Chart options={gastosArea
    .options} series={gastosArea.series} type="area" 
    height="132%"
    />

  </Paper>
 <PopupPortal />


  </Grid>

  


 )}

            <Grid sx={{mx: 0  ,my: -1  }} style={{width:'45%'}}>
            <Paper sx={{ p: 0 }} >
              <Typography variant="subtitle1"></Typography>
              <Chart options={lineaMargen.options} series={lineaMargen.series} type="line"  height="152%"  />

            </Paper>
            </Grid>
          

            <Grid sx={{mx: 0,my:-1 }}  style={{width:'48%'}}>
            <Paper sx={{ p: 0 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={chartRoaRoe.options} series={chartRoaRoe.series} type="bar" 
              height="152%"
              />

            </Paper>
            </Grid>
{/*
      <Grid sx={{mx: 0,my:2 }}  style={{width:'45%'}}>
      <Paper sx={{ p: 0 }} >
      <Chart
        options={ChartDataRegiones.options}
        series={ChartDataRegiones.series}
        type="pie"
        width={600}       // aumentar ancho, por ejemplo 600 px
        height={600}      // aumentar altura para que sea cuadrado y grande
      />
    </Paper>
     </Grid>   */}

     


        

       
{/*
            <Grid  sx={{ mx: -4, my: -4 }}>
         
           
              <Chart options={ejemploRadial.options} series={ejemploRadial.series} type="radialBar"  height={300} width="300" />

            </Grid>
*/}


{/*

            <Grid  sx={{ mx: 7, my: 1 }}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Divider sx={{ mx: -1, my: 1 }} />
              <Chart options={chartCrecimiento.options} series={chartCrecimiento.series} type="line"  height={250} width="350" />

            </Paper>
            </Grid>


          
             
          <Grid  sx={{ mx: 30, my: 1 }}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1">Ventas año 2023</Typography>
              <Divider sx={{ mx: -1, my: 1 }} />
              <Chart
                options={ejemploOptionChart1}
                series={[ejemploChart1]}
                type="bar"
                height={350}
                width="500"
                color="#FEB019"
              />
            </Paper>
            </Grid>



            <Grid>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1">Costo de ventas 2023</Typography>
              <Divider sx={{ mx: -1, my: 1 }} />
              <Chart options={ejemploOptionChart2.options} series={ejemploOptionChart2.series} type="line"  height={350} width="500" />

            </Paper>
            </Grid>

          

            <Grid  sx={{ mx: 30, my: 1 }}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1">Gastos administración 2023</Typography>
              <Divider sx={{ mx: -1, my: 1 }} />
              <Chart options={ejemploOptionChart4.options} series={ejemploOptionChart4.series} type="bar"  height={600} width="800" />

            </Paper>
            </Grid>


            <Grid>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1">Utilidad bruta 2023</Typography>
              <Divider sx={{ mx: -1, my: 1 }} />
              <Chart
                options={ejemploOptionChart3}
                series={[ejemploChart3]}
                type="bar"
                height={350}
                width="500"
                color="#FEB019"
              />
            </Paper>
            </Grid>


{/*
            <Grid sx={{ mx: 17 }}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1">Margen bruto 2023</Typography>
              <Divider sx={{ mx: -1, my: 1 }} />
              <Chart
                options={ejemploOptionChartMargen}
                series={[ejemploChartMargen]}
                type="bar"
                height={350}
                width="500"
                color="#FEB019"
              />
            </Paper>
            </Grid>




            <Grid  sx={{ mx: 30, my: 1 }}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1">ejemplo</Typography>
              <Divider sx={{ mx: -1, my: 1 }} />
              <Chart options={ejemplolinea.options} series={ejemplolinea.series} type="line"  height={500} width="800" />

            </Paper>
            </Grid>
*/}
    
          </Grid> 

      )
      

      
      }

    </Stack>
  );}
   else{
    if(tabValue==1){
    return (
    <Stack>
    {EstadoAnual? (
    <Fade in={true} timeout={3600}>
    <Paper sx={{ width: "100%", mb: 2 }}>
      <Stack py={10} alignItems="center" color="text.disabled">
        <TextSnippetIcon sx={{ fontSize: 120 }} />
        <Typography variant="h4">No data to display here</Typography>
      </Stack>
    </Paper>
  </Fade>
    ):(
        <Grid container spacing={{ xs: 0, md: -5 }}>
    
    <Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={cobrosArea
              .options} series={cobrosArea.series} type="area" 
              height="132%"
              />

            </Paper>
            </Grid>


  <Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={pagosArea
              .options} series={pagosArea.series} type="area" 
              height="132%"
              />

            </Paper>
            </Grid>

   <Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={inventarioArea
              .options} series={inventarioArea.series} type="area" 
              height="132%"
              />

            </Paper>
            </Grid>



 <Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={liquidezArea
              .options} series={liquidezArea.series} type="area" 
              height="132%"
              />

            </Paper>
            </Grid>

<Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={pruebaacida
              .options} series={pruebaacida.series} type="area" 
              height="132%"
              />

            </Paper>
            </Grid>

<Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={capitaltrabajo
              .options} series={capitaltrabajo.series} type="area" 
              height="132%"
              />

            </Paper>
            </Grid>





</Grid>

    )}
    </Stack>
    )
  }
  if(tabValue==2){
  return (
    <Stack>
      <Grid container spacing={{ xs: 0, md: -5 }}>
<Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={endeudamientoArea
              .options} series={endeudamientoArea.series} type="area" 
              height="132%"
              />

            </Paper>
            </Grid>


             <Grid sx={{mx: 0,my:2  }}  style={{width:'30%'}}>
            <Paper sx={{ p: 1 }}>
              <Typography variant="subtitle1"></Typography>
              <Chart options={apalancamientoArea
              .options} series={apalancamientoArea.series} type="area" 
              height="132%"
              />

            </Paper>
            </Grid>

          
</Grid>
    </Stack>
  )
  }
  if(tabValue==3 & Object.keys(RegionVentas).length>0){
  return (
    <Stack>
    <Grid container spacing={2}>
  
  <Grid item xs={12} md={6}>
    <Paper sx={{ p: 2 }}>
      <Chart
        options={ChartDataRegiones.options}
        series={ChartDataRegiones.series}
        type="pie"
        width="100%"
        height={450}
      />
    </Paper>
  </Grid>

  <Grid item xs={12} md={6}>
    <Paper sx={{ p: 2 }}>
      <Chart
        options={ChartDataAsesores.options}
        series={ChartDataAsesores.series}
        type="pie"
        width="100%"
        height={450}
      />
    </Paper>
  </Grid>

</Grid>
    </Stack>
  )}
  else{
    return (
    <Stack>
 <Fade in={true} timeout={3600}>
    <Paper sx={{ width: "100%", mb: 2 }}>
      <Stack py={10} alignItems="center" color="text.disabled">
        <TextSnippetIcon sx={{ fontSize: 120 }} />
        <Typography variant="h4">No data to display in region</Typography>
      </Stack>
    </Paper>
  </Fade>
</Stack>
    )
  }
  
      }

}

}
